import { createComponent, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { NgxUiLoaderConfig, NgxUiLoaderService, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';
import { ToastrService, ActiveToast } from 'ngx-toastr';

declare const copyToClipboard: any;

import { AppConfigService } from './app-config.service';
import { BehaviorSubject, Observable, pipe, Subject } from 'rxjs';
// Component imports removed for standalone app - not needed for HL7 viewer
import { DateTime } from 'luxon';
import { DatePattern, LookUp } from './model';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  config: NgxUiLoaderConfig = {
    bgsSize: 50,
    bgsType: SPINNER.threeStrings,
    fgsType: SPINNER.threeStrings,
    fgsSize: 80,
    pbDirection: PB_DIRECTION.leftToRight,
    pbThickness: 5,
    overlayColor: 'rgba(20,20,20,.6)'
  };
  isprocessEditedMappingData = "";
  isprocessEditedtemplatedId = 0;
  lasturl='';
  CaseDataDetails={}
  protected apiURL: string = AppConfigService.settings.WebApiURL;
  protected UserLogin: string = AppConfigService.settings.UserLogin;
  islock: boolean = false;
  private messageSource = new BehaviorSubject(false);
  currentMessage = this.messageSource.asObservable();
  private configdatarefresh = new BehaviorSubject(false);
  dataRefreshConfig = this.configdatarefresh.asObservable();
  private viewFilecase = new BehaviorSubject(false);
  viewfileview = this.viewFilecase.asObservable();

  private vendoreCreate = new BehaviorSubject(false);
  vendorUpdate = this.vendoreCreate.asObservable();

  private updatessostatus = new BehaviorSubject(false);
  servicessostatus = this.updatessostatus.asObservable();

  private updatCaseXml = new BehaviorSubject('');
  UpdatedXmlData = this.updatCaseXml.asObservable();

  private messageSourceInterface = new Subject();
  currentMessageinterface = this.messageSourceInterface.asObservable();
  private configJson = new Subject();
  ConfigJsonFlag = this.configJson.asObservable();
  configDetails: any;
  usersessiontoken: any = "2";
  invalidrefreshtoken: boolean = false;
  messagesData = "";
  openedModalConfig =""
  isopenAlready = false
  header = { withCredentials: true }
  headers = { 'Content-Type': 'application/json charset = utf-8', withCredentials: true };
  ComponentsList: any[] = [] // Empty for standalone app - not needed for HL7 viewer
  private pipelineNameSource = new Subject<string | null>();
  pipelineName$ = this.pipelineNameSource.asObservable();

  setPipelineName(pipelineName: string) {
    this.pipelineNameSource.next(pipelineName);
  }

  private pipelineNameSource_2 = new Subject<string | null>();
  pipelineName_2$ = this.pipelineNameSource_2.asObservable();

  setPipelineName_2(pipelineName: string) {
    setTimeout(() => {
      this.pipelineNameSource_2.next(pipelineName);
    }, 2000);
  }

  private messageInterface = new Subject<string | null>();
  message$ = this.messageInterface.asObservable();
  setMessageObj(data: any) {
    this.messageInterface.next(data);
  }

  private vendorlistcomp = new Subject<string | null>();
  vendorinterface$ = this.vendorlistcomp.asObservable();
  setvenintObj(data: any) {
    this.vendorlistcomp.next(data);
  }

  private case360int = new Subject<string | null>();
  case360interface$ = this.case360int.asObservable();
  setcaseintObj(body: any) {
    this.case360int.next(body);
  }
  private case360int_2 = new Subject<string | null>();
  case360interface_2$ = this.case360int_2.asObservable();
  setcaseintObj_2(body: any) {
    setTimeout(() => {
    this.case360int_2.next(body);
  }, 2000);
  }

  private msgcase360 = new Subject<string | null>();
  msgtocase360$ = this.msgcase360.asObservable();
  setmsgcaseObj(body: any) {
    this.msgcase360.next(body);
  }

  private msgcase360_2 = new Subject<string | null>();
  msgtocase360_2$ = this.msgcase360_2.asObservable();
  setmsgcaseObj_2(body: any) {
    setTimeout(() => {
      this.msgcase360_2.next(body);
    }, 2000);
  }

  //#region Timezone related changes.
  // In this array the key "pattern" is used to check the incoming and outgoing string to decide whether it is a datetime string or not.
  // The key "inputFormat" is used to parse the incoming string to a Luxon DateTime object.
  // The key "outputFormat" is used to format the Luxon DateTime object to a string. Here care should be taken that the output format should be same as the input format.
  // The key "formatFunction" is used to format the Luxon DateTime object to a string. Here extensive care should be taken to format the string to the original format. Any other format will break the system.
  // The key "name" is used to identify the pattern.
  private readonly datePatterns: DatePattern[] = [
    // ISO 8601 - Date only (e.g. 2025-09-17)
    { pattern: /^\d{4}-\d{2}-\d{2}$/, name: 'isoDateOnly', inputFormat: 'yyyy-MM-dd', outputFormat: 'yyyy-MM-dd', formatFunction: (dt) => dt.toFormat('yyyy-MM-dd') },
  
    // ISO 8601 - Date + Time (e.g. 2025-09-17T13:32:45)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/, name: 'isoDateTime', inputFormat: 'yyyy-MM-ddTHH:mm:ss', outputFormat: 'yyyy-MM-ddTHH:mm:ss', formatFunction: (dt) => dt.toISO().split('.')[0].replace(/[+\-]\d{2}:\d{2}$/, '') },
  
    // ISO 8601 - Date + Time with space (e.g. 2025-09-22 00:00:00)
    { pattern: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/, name: 'isoDateTimeSpace', inputFormat: 'yyyy-MM-dd HH:mm:ss', outputFormat: 'yyyy-MM-dd HH:mm:ss' },
  
    // ISO 8601 - Date + Time + milliseconds (e.g. 2025-09-17T13:32:45.123)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}$/, name: 'isoDateTimeMillis', inputFormat: 'yyyy-MM-ddTHH:mm:ss.SSS', outputFormat: 'yyyy-MM-ddTHH:mm:ss.SSS', formatFunction: (dt) => dt.toISO().replace(/[+\-]\d{2}:\d{2}$/, '') },
  
    // ISO 8601 - Date + Time + 2-digit milliseconds (e.g. 2025-09-08T09:44:27.55)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{2}$/, name: 'isoDateTimeMillis2', inputFormat: 'yyyy-MM-ddTHH:mm:ss.SS', outputFormat: 'yyyy-MM-ddTHH:mm:ss.SS', formatFunction: (dt) => dt.toISO().replace(/[+\-]\d{2}:\d{2}$/, '').replace(/\.\d{3}/, '.' + dt.millisecond.toString().padStart(2, '0')) },
  
    // ISO 8601 - Date + Time + milliseconds + Z (e.g. 2025-09-17T13:32:45.123Z)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, name: 'isoDateTimeMillisZ', inputFormat: 'yyyy-MM-ddTHH:mm:ss.SSSZ', outputFormat: 'yyyy-MM-ddTHH:mm:ss.SSSZ', formatFunction: (dt) => dt.toUTC().toISO().replace(/[+\-]\d{2}:\d{2}$/, 'Z') },
  
    // ISO 8601 - Date + Time + Z (e.g. 2025-09-17T13:32:45Z)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, name: 'isoDateTimeZ', inputFormat: 'yyyy-MM-ddTHH:mm:ssZ', outputFormat: 'yyyy-MM-ddTHH:mm:ssZ', formatFunction: (dt) => dt.toUTC().toISO().replace(/[+\-]\d{2}:\d{2}$/, 'Z') },
  
    // ISO 8601 - Date + Time + offset (e.g. 2025-09-17T13:32:45+05:30)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+\-]\d{2}:\d{2}$/, name: 'isoDateTimeOffset', inputFormat: 'yyyy-MM-ddTHH:mm:ssZZ', outputFormat: 'yyyy-MM-ddTHH:mm:ssZZ' },
  
    // ISO 8601 - Date + Time + milliseconds + offset (e.g. 2025-09-17T13:32:45.123-04:00)
    { pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}[+\-]\d{2}:\d{2}$/, name: 'isoDateTimeMillisOffset', inputFormat: 'yyyy-MM-ddTHH:mm:ss.SSSZZ', outputFormat: 'yyyy-MM-ddTHH:mm:ss.SSSZZ' },
  
    // European format - dd-MM-yyyy HH:mm:ss (e.g. 17-09-2025 13:32:45)
    { pattern: /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/, name: 'europeanDateTime', inputFormat: 'dd-MM-yyyy HH:mm:ss', outputFormat: 'dd-MM-yyyy HH:mm:ss' },
    
    // European format with exactly one trailing space - dd-MM-yyyy HH:mm:ss (e.g. 17-09-2025 13:32:45 )
    { pattern: /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}\s$/, name: 'europeanDateTimeWithSpace', inputFormat: 'dd-MM-yyyy HH:mm:ss ', outputFormat: 'dd-MM-yyyy HH:mm:ss ', formatFunction: (dt) => dt.toFormat('dd-MM-yyyy HH:mm:ss') + ' ' },
  
    // European format - dd-MM-yyyy HH:mm:ss.SSS (e.g. 17-09-2025 13:32:45.123)
    { pattern: /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}\.\d{3}$/, name: 'europeanDateTimeMillis', inputFormat: 'dd-MM-yyyy HH:mm:ss.SSS', outputFormat: 'dd-MM-yyyy HH:mm:ss.SSS' },
  
    // Optional format - yyyy/MM/dd HH:mm:ss (e.g. 2025/09/17 13:32:45)
    { pattern: /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/, name: 'slashDateTime', inputFormat: 'yyyy/MM/dd HH:mm:ss', outputFormat: 'yyyy/MM/dd HH:mm:ss' },
  
    // Optional format - yyyy/MM/dd HH:mm:ss.SSS (e.g. 2025/09/17 13:32:45.123)
    { pattern: /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/, name: 'slashDateTimeMillis', inputFormat: 'yyyy/MM/dd HH:mm:ss.SSS', outputFormat: 'yyyy/MM/dd HH:mm:ss.SSS' },

    // US format - M/d/yyyy h:mm:ss a (e.g. 9/24/2025 1:39:54 PM)
    { pattern: /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} [AP]M$/, name: 'usDateTimeAMPM', inputFormat: 'M/d/yyyy h:mm:ss a', outputFormat: 'M/d/yyyy h:mm:ss a', formatFunction: (dt) => dt.toFormat('M/d/yyyy h:mm:ss a') },

    // US format - MM/dd/yyyy HH:mm:ss (e.g. 09/25/2025 14:32:23)
    { pattern: /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/, name: 'usDateTime24Hour', inputFormat: 'MM/dd/yyyy HH:mm:ss', outputFormat: 'MM/dd/yyyy HH:mm:ss' },

    // US format - MM/dd/yyyy HH:mm:ss.SSS (e.g. 09/26/2025 06:17:19.000)
    { pattern: /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}\.\d{3}$/, name: 'usDateTime24HourMillis', inputFormat: 'MM/dd/yyyy HH:mm:ss.SSS', outputFormat: 'MM/dd/yyyy HH:mm:ss.SSS', formatFunction: (dt) => dt.toFormat('MM/dd/yyyy HH:mm:ss') + '.' + dt.millisecond.toString().padStart(3, '0') }
  ];
  private selectedTimezone: string = localStorage.getItem('selectedTimezone') || 'EST';

  private mapTimezoneShorthand(shorthand: string): string {
    const timezoneMap: { [key: string]: string } = {
      'UTC': 'UTC',
      'IST': 'Asia/Kolkata',
      'EST': 'America/New_York',
      'PST': 'America/Los_Angeles',
      'CST': 'America/Chicago'
      // Add more as needed
    };
    
    return timezoneMap[shorthand] || shorthand;
  }
  
  setTimezone(tz: string) {
    this.selectedTimezone = tz || 'UTC';
    localStorage.setItem('selectedTimezone', this.selectedTimezone);
  }
  getTimezone(): string {
    const selectedTz = this.selectedTimezone || 'UTC';
    return this.mapTimezoneShorthand(selectedTz);
  }
  
  getTimezoneForDisplay(): string {
    return this.selectedTimezone || 'UTC';
  }

  // HL7 Mapping APIs
  convertHL7ToXML(hl7Raw: string): Observable<string> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/convert`;
    const headers = new HttpHeaders({ 'Content-Type': 'text/plain' });
    return this.httpService.post(url, hl7Raw || '', { headers, responseType: 'text' });
  }

  getMappedXML(interfaceId: string, processorAgentId: string): Observable<string> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mapped-xml`;
    return this.httpService.post(url, { interfaceId, processorAgentId }, { responseType: 'text' });
  }

  getHL7Mappings(hl7Raw: string, interfaceId: string, processorAgentId: string): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mappings`;
    return this.httpService.post(url, { hl7Raw, interfaceId, processorAgentId });
  }

  getHl7WithLineNumbers(hl7Raw: string): Observable<string> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/with-line-numbers`;
    return this.httpService.post(url, { hl7Raw }, { responseType: 'text' });
  }

  downloadMappingExcel(hl7Raw: string, interfaceId: string, processorAgentId: string): Observable<Blob> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mappings/download-excel`;
    return this.httpService.post(url, { hl7Raw, interfaceId, processorAgentId }, { responseType: 'blob' });
  }

  getFilteredHL7Mappings(hl7Raw: string, interfaceId: string, processorAgentId: string, currentSegmentLine?: string, segmentHeader?: string, segIndex?: string): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mappings/filtered`;
    return this.httpService.post(url, { 
      hl7Raw, 
      interfaceId, 
      processorAgentId,
      currentSegmentLine: currentSegmentLine || null,
      segmentHeader: segmentHeader || null,
      segIndex: segIndex || null
    });
  }

  /**
   * Gets repeatable node context for alias paths by analyzing the mapped XML structure.
   * Returns a dictionary mapping alias XPaths to their repeatable context (parent, variable, segment).
   */
  getRepeatableContext(interfaceId: string, processorAgentId: string): Observable<{
    repeatableContext: { [aliasPath: string]: {
      repeatableParent: string;
      parentVariable: string | null;
      parentSegment: string;
      repeatablePath: string;
    }}
  }> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/repeatable-context`;
    return this.httpService.post<{
      repeatableContext: { [aliasPath: string]: {
        repeatableParent: string;
        parentVariable: string | null;
        parentSegment: string;
        repeatablePath: string;
      }}
    }>(url, { interfaceId, processorAgentId });
  }

  saveHL7Mapping(mappingData: any): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mappings/save`;
    return this.httpService.post(url, mappingData);
  }

  deleteHL7Mapping(mappingData: any): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mappings/delete`;
    return this.httpService.post(url, mappingData);
  }

  // CHANGED: Batch save method for batch editing
  // REVERT: Remove this method to revert
  saveBatchHL7Mappings(batchData: {
    interfaceId: string,
    processorAgentId: string,
    changes: Array<{
      action: 'add' | 'delete' | 'update',
      hl7Path: string,
      xmlPath: string,
      condition: string,
      originalMapping?: { hl7Path: string, xmlPath: string, condition: string }
    }>,
    hl7Raw: string
  }): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/mappings/batch-save`;
    return this.httpService.post(url, batchData);
  }

  /**
   * Gets expression functions configuration for the HL7 expression builder.
   * These functions can be used to build custom expressions in mappings.
   */
  getHL7ExpressionFunctions(): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/expression-functions`;
    return this.httpService.get(url);
  }

  /**
   * Saves expression functions configuration (admin only).
   */
  saveHL7ExpressionFunctions(config: any): Observable<any> {
    const base = (this.apiURL || '').replace(/\/$/, '');
    const url = `${base}/api/hl7/expression-functions`;
    return this.httpService.post(url, config);
  }

  /**
   * Process serialized data by finding and converting serialized strings anywhere in the data structure
   * @param data - The data to process (can be any type: object, array, string, etc.)
   * @returns Processed data with all serialized strings converted and datetimes processed
   */
  processSerializedDataWithDateTimeConversion(data: any): any {
    try {
      // If data is null or undefined, return as is
      if (data === null || data === undefined) {
        return data;
      }

      // If data is a string, check if it's a serialized JSON
      if (typeof data === 'string') {
        if (this.IsJsonString(data)) {
          // Deserialize, convert datetimes, and serialize back
          const deserializedData = JSON.parse(data);
          const convertedData = this.transformDatesDeep(deserializedData);
          return JSON.stringify(convertedData);
        } else {
          // Regular string, just convert datetimes if any
          return this.transformDatesDeep(data);
        }
      }

      // If data is an array, process each element recursively
      if (Array.isArray(data)) {
        return data.map(item => this.processSerializedDataWithDateTimeConversion(item));
      }

      // If data is an object, process each property recursively
      if (typeof data === 'object') {
        const processedObject: any = {};
        for (const [key, value] of Object.entries(data)) {
          processedObject[key] = this.processSerializedDataWithDateTimeConversion(value);
        }
        return processedObject;
      }

      // For primitive types (number, boolean, etc.), just convert datetimes if any
      return this.transformDatesDeep(data);

    } catch (error) {
      console.error('Error processing serialized data:', error);
      // Return original data if processing fails
      return data;
    }
  }
  
  private isDateString(val: any): val is string {
    if (typeof val !== 'string') return false;
    return this.datePatterns.some(({ pattern }) => pattern.test(val));
  }

  /**
   * Parses a datetime string using multiple format attempts
   * @param datetimeString - The datetime string to parse
   * @returns Parsed Luxon DateTime object
   */
  private parseDateTimeString(datetimeString: string): DateTime {
    // First try ISO format (most common and fastest)
    let sourceDateTime = DateTime.fromISO(datetimeString, { zone: 'UTC' });
    
    // If ISO fails, try each pattern from the array
    if (!sourceDateTime.isValid) {
      for (const pattern of this.datePatterns) {
        if (pattern.pattern.test(datetimeString)) {
          sourceDateTime = DateTime.fromFormat(datetimeString, pattern.inputFormat, { zone: 'UTC' });
          if (sourceDateTime.isValid) {
            break; // Found a working format
          }
        }
      }
    }
    
    // Validate that we have a valid datetime
    if (!sourceDateTime.isValid) {
      throw new Error(`Invalid datetime format: ${sourceDateTime.invalidReason || 'Unknown error'}`);
    }
    
    return sourceDateTime;
  }

  /**
   * Parses a datetime string in the user's timezone (for UTC conversion)
   * @param datetimeString - The datetime string to parse in user's timezone
   * @returns Parsed Luxon DateTime object in user's timezone
   */
  private parseDateTimeStringInUserTimezone(datetimeString: string): DateTime {
    const userTimezone = this.getTimezone();
    
    // First try ISO format in user's timezone (most common and fastest)
    let sourceDateTime = DateTime.fromISO(datetimeString, { zone: userTimezone });
    
    // If ISO fails, try each pattern from the array
    if (!sourceDateTime.isValid) {
      for (const pattern of this.datePatterns) {
        if (pattern.pattern.test(datetimeString)) {
          sourceDateTime = DateTime.fromFormat(datetimeString, pattern.inputFormat, { zone: userTimezone });
          if (sourceDateTime.isValid) {
            break; // Found a working format
          }
        }
      }
    }
    
    // If all parsing attempts fail, throw an error
    if (!sourceDateTime.isValid) {
      throw new Error(`Invalid datetime format: ${sourceDateTime.invalidReason || 'Unknown error'}`);
    }
    
    return sourceDateTime;
  }

  /**
   * Formats a Luxon DateTime to match the original format
   * @param targetDateTime - The converted Luxon DateTime object
   * @param originalDateTimeString - The original datetime string to match format
   * @returns The formatted datetime string matching the original format
   */
  private formatDateTimeToOriginalFormat(targetDateTime: DateTime, originalDateTimeString: string): string {
    // Find the matching date pattern to preserve format
    const matchingPattern = this.datePatterns.find(pattern => pattern.pattern.test(originalDateTimeString));
    
    if (matchingPattern) {
      // Check if it has a custom formatFunction for special cases
      if (matchingPattern.formatFunction) {
        return matchingPattern.formatFunction(targetDateTime);
      }
      // Otherwise use the standard outputFormat for simple cases
      if (matchingPattern.outputFormat) {
        return targetDateTime.toFormat(matchingPattern.outputFormat);
      }
    }

    // Fallback to standard ISO format if no pattern matches
    return targetDateTime.toISO();
  }

  /**
   * Converts a UTC datetime string to the selected timezone
   * @param datetimeString - The datetime string to convert (ISO 8601 or other supported formats)
   * @returns The converted datetime string in the same format as input
   */
  convertDateTimeString(datetimeString: string): string {
    // Input validation
    if (!datetimeString || typeof datetimeString !== 'string') {
      return datetimeString; // Return original string if input is invalid
    }

    try {
      // Parse the datetime string using the parse method
      const sourceDateTime = this.parseDateTimeString(datetimeString);

      // Convert to target timezone (from service setting)
      const targetTimezone = this.getTimezone();
      const targetDateTime = sourceDateTime.setZone(targetTimezone);

      // Validate the conversion was successful
      if (!targetDateTime.isValid) {
        return datetimeString; // Return original string if conversion fails
      }

      // Format the datetime to match the original format
      return this.formatDateTimeToOriginalFormat(targetDateTime, datetimeString);

    } catch (error) {
      // Return original string if conversion fails
      return datetimeString;
    }
  }

  /**
   * Converts a datetime string from user's timezone to UTC (reverse of convertDateTimeString)
   * @param datetimeString - The datetime string to convert from user timezone to UTC
   * @returns The converted datetime string in UTC, same format as input
   */
  private convertDateTimeStringToUTC(datetimeString: string): string {
    // Input validation
    if (!datetimeString || typeof datetimeString !== 'string') {
      return datetimeString; // Return original string if input is invalid
    }

    try {
      // Parse the datetime string in the user's timezone using the dedicated method
      const sourceDateTime = this.parseDateTimeStringInUserTimezone(datetimeString);

      // Convert to UTC (opposite direction of convertDateTimeString)
      const utcDateTime = sourceDateTime.toUTC();

      // Validate the conversion was successful
      if (!utcDateTime.isValid) {
        return datetimeString;
      }

      // Format the datetime to match the original format but in UTC
      return this.formatDateTimeToOriginalFormat(utcDateTime, datetimeString);

    } catch (error) {
      // Return original string if conversion fails
      return datetimeString;
    }
  }

  /**
   * Transforms datetime fields in any data structure from user timezone to UTC
   * @param data - The data to transform (can be object, array, string, etc.)
   * @returns Transformed data with datetime fields converted to UTC
   */
  private transformOutboundValueToUTC(data: any): any {
    if (data == null || data === undefined) {
      return data;
    }

    // If user is already in UTC, no conversion needed
    if (this.getTimezone() === 'UTC') {
      return data;
    }

    const visit = (v: any): any => {
      if (Array.isArray(v)) return v.map(visit);
      
      // Handle Date objects BEFORE object type check
      if (v instanceof Date) {
        return this.convertDateTimeStringToUTC(v.toISOString());
      }
      
      if (v && typeof v === 'object') {
        return this.processObjectValue(v, visit);
      }
      
      return this.processPrimitiveValue(v);
    };
    return visit(data);
  }

  private processObjectValue(obj: any, visit: (v: any) => any): any {
    const out: any = Array.isArray(obj) ? [] : {};
    for (const k of Object.keys(obj)) {
      const child = obj[k];
      if (child && typeof child === 'object') {
        out[k] = visit(child);
      } else {
        out[k] = this.processPrimitiveValue(child);
      }
    }
    return out;
  }

  private processPrimitiveValue(value: any): any {
    if (value instanceof Date) {
      return this.convertDateTimeStringToUTC(value.toISOString());
    }
    return this.isDateString(value) ? this.convertDateTimeStringToUTC(value) : value;
  }

  /**
   * Transforms datetime fields in URL strings from user timezone to UTC
   * @param url - The URL string that may contain datetime values
   * @returns URL with datetime fields converted to UTC
   */
  private transformUrlToUTC(url: string): string {
    if (!url || typeof url !== 'string') {
      return url;
    }

    // If user is already in UTC, no conversion needed
    if (this.getTimezone() === 'UTC') {
      return url;
    }

    // Build a combined regex from datePatterns to keep this in sync centrally
    const combinedPattern = this.datePatterns
      .map(p => p.pattern.source)
      .join('|');

    const regex = new RegExp(combinedPattern, 'g');

    let transformedUrl = url.replace(regex, (match) => this.convertDateTimeStringToUTC(match));

    return transformedUrl;
  }

// Returns a new structure (non-mutating). Only converts leaves, not objects/arrays.
transformDatesDeep<T>(data: T, formatOptions?: Intl.DateTimeFormatOptions): T {
  // Early return for null/undefined data
  if (data == null || data === undefined) {
    return data; // Return as-is if null/undefined
  }

  // Early return if timezone is UTC
  if (this.getTimezone() === 'UTC') {
    return data; // No conversion needed
  }
  // We only convert the date time based on timezone if that is not UTC
  const processValue = (value: any): any => {
    return this.isDateString(value) ? this.convertDateTimeString(value) : value;
  };

  const visit = (v: any): any => {
    if (Array.isArray(v)) return v.map(visit);
    if (v && typeof v === 'object') {
      const out: any = {};
      for (const k of Object.keys(v)) {
        const child = v[k];
        out[k] = (child && typeof child === 'object') ? visit(child) : processValue(child);
      }
      return out;
    }
    return processValue(v);
  };
  return visit(data);
}
//#endregion


  stopEmitting(displayname:string) {
    switch(displayname.toLowerCase()){
      case 'create':
        this.pipelineNameSource.next(null);
        break; 
      case 'messages':
        this.messageInterface.next(null);
        break; 
      case 'interface':
        this.vendorlistcomp.next(null);
        //this.case360int.next(null);
        break; 
    }
  }
  constructor(private httpService: HttpClient,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService) {
    this.config = this.ngxUiLoaderService.getDefaultConfig();
    this.apiURL = window.location.origin.includes('.com') ? AppConfigService.settings.WebApiDotComURL : AppConfigService.settings.WebApiURL;
    console.log("common service Web API URL: ", this.apiURL);
  }

  copyableToastError(message: string, title: string = "", options?: any): ActiveToast<any> {
    const toastOptions = {
      timeOut: 4000,
      positionClass: "toast-bottom-right",
      ...options
    };

    const toast = this.toastr.error(message, title, toastOptions);

    toast.onTap.subscribe(() => {
      if (typeof copyToClipboard === 'function') {
        copyToClipboard(message);
        this.toastr.success("Message copied to clipboard", "", {
          timeOut: 500,
          positionClass: "toast-bottom-right"
        });
      }
    });

    return toast;
  }

  getapiurl(urlterm) {
    // Transform URL to convert any datetime fields to UTC
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);

    let listOfNames = this.httpService.get(transformedUrl, this.header)
      .pipe(
        debounceTime(500),  // WAIT FOR 500 MILISECONDS ATER EACH KEY STROKE.
        map(
          (data: any) => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return (
              convertedData as any[]
            );
          }
        ));

    return listOfNames;
  }

  async postapi(urlterm: any, createSearch: any) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    const transformedBody = this.transformOutboundValueToUTC(createSearch);

    return await this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);
  }

  async searchpostapi(urlterm, createSearch: any) {
    const headers = {
      'Content-Type': 'application/json charset = utf-8'
    };

    // Transform URL and request body to convert any datetime fields to UTC
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    const transformedBody = this.transformOutboundValueToUTC(createSearch);

    return await this.httpService.post<any>(transformedUrl, JSON.stringify(transformedBody), { headers, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);

  }

  //Used this method where we do not want the effect of timezone.
  async searchpostapiWithOutTimezoneConversion(urlterm, createSearch: any) {
    const headers = {
      'Content-Type': 'application/json charset = utf-8'
    };


    return await this.httpService.post<any>(this.apiURL + urlterm, JSON.stringify(createSearch), { headers, withCredentials: true })
      .pipe().toPromise()
      .then(result => result)
      .catch(err => err);
  }

  response: any[];
   savemappings(mappingentity, apiname) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const transformedUrl = this.transformUrlToUTC(this.apiURL + apiname);
    const transformedBody = this.transformOutboundValueToUTC(mappingentity);
    return  this.httpService.post<any>(transformedUrl, transformedBody, { headers, withCredentials: true, responseType: 'text' as 'json' })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }


  async deletemapping(apinamevalue) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + apinamevalue);
    return await this.httpService.delete(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);
  }


  async filedownloadblob(urlterm, header: any) {
    const headers = header;
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return await this.httpService.get<any>(transformedUrl, { headers, withCredentials: true, responseType: 'blob' as 'json' })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  async getapi(urlterm) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return await this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);

  }

 dataValidationapi(parameter:any){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/DataValidation/ValidateCaseData`);
  const transformedBody = this.transformOutboundValueToUTC(parameter);
  return this.httpService.post<any>( transformedUrl, transformedBody,{withCredentials: true})
     .pipe(
       map(data => {
         //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
         const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
         return convertedData;
       })
     );
}
  async reprocessStageapi(urlterm, createSearch: any) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    const transformedBody = this.transformOutboundValueToUTC(createSearch);
    return await this.httpService.post<any>(transformedUrl, transformedBody, { withCredentials: true, responseType: 'text' as 'json' })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);

  }

  async dxpostapi(urlterm, entity) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    const transformedBody = this.transformOutboundValueToUTC(entity);
    return await this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);

  }
  dxgetapi(urlterm, deploymentkey) {
    const headers = { 'Conn': deploymentkey };
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return this.httpService.get(transformedUrl, { headers ,withCredentials: true,})
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );

  }
  getapiurlcontenttext(urlterm) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return this.httpService.get<any>(transformedUrl, { withCredentials: true, responseType: 'json' })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getapiurlcontent(urlterm) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  // for entity api
  async entitygetapi(createSearch: any) {
    const transformedBody = this.transformOutboundValueToUTC(createSearch);
    return await this.httpService.post<any>(this.apiURL, transformedBody, this.headers)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);
  }


  //audit save
  async auditsave(actiontype: string, oldvalue: any, newvalue: any, context: any, contextid: any,description:any) {
    var apiname = 'api/Audit/SaveAudit';
    var auditobj = {
      "UserName": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'],
      "ActionType": actiontype,
      "OldValue": oldvalue,
      "NewValue": newvalue,
      "Context": context,
      "ContextId": contextid,
      "Description":description
    }
    const transformedUrl = this.transformUrlToUTC(this.apiURL + apiname);
    const transformedBody = this.transformOutboundValueToUTC(auditobj);
    return await this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);
  }


  async uploadExcel(urlterm, file: any) {
    // const headers = new HttpHeaders().append('Content-Type', 'Plain/Text');
    var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    const headers = {
      'Content-Type': 'Plain/Text'
    };
    const formData = new FormData();
    formData.append('file', file, file.name);

    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    // Do not transform FormData body
    return this.httpService.post<any>(transformedUrl, formData, { headers, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);
  }

  checksession() {
    // var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    // if (sessionObject != null) {
    //   return true;
    // }
    // else {
    //   sessionStorage.removeItem('sessionObjectlogin');
    //   return false;
    // }
    return true;
  }
  checkserversession() {
    // Standalone app - no login service needed, return empty observable
    return new Observable(observer => {
      observer.next({});
      observer.complete();
    });
  }


  async postapiwithurl(fullurlterm: any, inputentity: any, apiheaders: any) {

    apiheaders["Content-Type"] = "application/json";
    apiheaders["Access-Control-Allow-Origin"] = "*";
    apiheaders["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";
    apiheaders["Access-Control-Allow-Methods"] = "GET,POST,OPTIONS,DELETE,PUT";
    const transformedUrl = this.transformUrlToUTC(fullurlterm);
    const transformedBody = this.transformOutboundValueToUTC(inputentity);
    return await this.httpService.post<any>(transformedUrl, JSON.stringify(transformedBody), { headers: apiheaders })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);
  }

  uploadFile(urlterm, theFile: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), withCredentials: true
    };
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return this.httpService.post<any>(transformedUrl, theFile, httpOptions)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  changeMessage(ischeck: boolean) {
    this.messageSource.next(ischeck)
  }
  changeConfigmodal(ischeck: boolean) {
    this.configdatarefresh.next(ischeck)
  }
  closeviewFile(ischeck: boolean) {
    this.viewFilecase.next(ischeck)
  }
  changeModal(isSize: object) {
    this.configJson.next(isSize)
  }
  changeJson(isSize: object) {
    this.configJson.next(isSize)
  }

  vendorStatus(update: boolean) {

    this.vendoreCreate.next(update)
  }

  XmlModification(xml) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/GetMappings/ConvertXML`);
    const transformedBody = this.transformOutboundValueToUTC(xml);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.headers)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  Hubmessage_IOTData(uniqueid,payloadreference, Archive) {
    let createdby=JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid'];
    //return this.httpService.get(`${this.apiURL}api/HubMessage/GetInputTransformOutputData?messageRefId=${uniqueid}&fileid=${payloadreference}&archivedbcheck=${Archive}&createdby=${createdby}`, this.header)
  
       let obj={
        messageRefId:uniqueid,
        fileid:payloadreference,
        archivedbcheck:Archive,
        createdby:createdby
      }
      const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/HubMessage/GetInputTransformOutputData`);
      const transformedBody = this.transformOutboundValueToUTC(obj);
      return this.httpService.post<any>(transformedUrl, transformedBody, this.headers)
        .pipe(
          map(data => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return convertedData;
          })
        )
  
      
  }
  downloadfile(urlterm): Observable<HttpResponse<Blob>> {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}${urlterm}`);
    return this.httpService.get(transformedUrl, { withCredentials: true, responseType: 'blob', observe: 'response' })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  getmetricapiurl(urlterm) {
    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    let listOfNames = this.httpService.get(transformedUrl, this.header)
      .pipe(
        debounceTime(500),
        map(
          (data: any) => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return (
              convertedData as any[]
            );
          }
        ));

    return listOfNames;
  }
  transformAlphabetically(array: any[], field: string): any[] {
    return array.sort((a, b) => a[field].toLowerCase() !== b[field].toLowerCase() ? a[field].toLowerCase() < b[field].toLowerCase() ? -1 : 1 : 0);
  }

  clearCache() {
    var id=JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CoreCache/DeleteCache?userid=${id}`);
    return this.httpService.post<any>(transformedUrl,'', this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  getJobSearch(job) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Jobs/GetJobSearch`);
    const transformedBody = this.transformOutboundValueToUTC(job);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.headers)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  createJob(job) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Jobs/SaveJob`);
    const transformedBody = this.transformOutboundValueToUTC(job);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.headers)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  getJobLogs(jobid: string, currentPage: number, itemsPerPage: number) {
    const rawUrl = `${this.apiURL}api/Jobs/GetJobLogs?jobid=${jobid}&pageNumber=${currentPage}&pageSize=${itemsPerPage}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(
      transformedUrl,
      this.headers
    )
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
    );
  } 

  IsJsonString(str) {
    let isvalid = false;
    try {
      JSON.parse(str);
      isvalid = true;
    } catch (e) {
      isvalid = false;
    }
    return isvalid
  }



  // InterfaceCIIS service will start from here

  getInterfaces() {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/GetInterfaceList/GetInterfacescon `);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getInterfaceFilters(interfacename: any, engine: any, vendor: any) {
    const rawUrl = `${this.apiURL}api/VAInterfaces/GetVAInterfacesbysearch?interfacename=${interfacename}&Engine=${engine}&Vendor=${vendor}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getfilterdata(column: any, userinput: any) {
    const rawUrl = `${this.apiURL}api/InterfaceFieldFilter/GetInterfacesfieldsearch?column=${column}&userinput=${userinput}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getSearchFilterData(body: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfacebyInput/GetVAInterfaces`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  changeMessageinterface(message: string) {
    this.messageSourceInterface.next(message)
  }
  getDescription() {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/ConnectivityTypes/vaConnectivityTypes`);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  HubMapping(Interfacegroupid: any, Processorid: any) {
    var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    const rawUrl = `${this.apiURL}api/InterfacePipelineConfig/pipelineconfigdata?token=${sessionObject.userdata['usertokenString']}&interfacegrpid=${Interfacegroupid}&processorid=${Processorid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getAudit(interfaceidentifier: any, engine: any, deployment: any) {
    const rawUrl = `${this.apiURL}api/InterfaceAudit/getAuditsData?InterfaceName=${interfaceidentifier}&InterfaceType=${engine}&Connection=${deployment}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  getHubAudit(id: any) {
    const rawUrl = `${this.apiURL}api/Audit/GetAuditDetails?id=${id}&context=Pipeline`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getHubView(Interfacegroupid: any) {
    const rawUrl = `${this.apiURL}api/InterfaceHub/getHubViewData?Interfacegroupid=${Interfacegroupid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getFolders(interfaceid: any) {
    const rawUrl = `${this.apiURL}api/InterfaceFiles/getFilesData?InterfaceId=${interfaceid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.headers)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getTransactions(interfacename: any, Engine: any, Deployment: any) {
    const rawUrl = `${this.apiURL}api/InterfaceTransactions/getTransactionData?interfacename=${interfacename}&InterfaceType=${Engine}&Connection=${Deployment}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getHandlesData(interfacename: any) {
    const rawUrl = `${this.apiURL}api/IntergrationMapping/getIntegrationData/${interfacename}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getRulesData(interfacename: any) {
    const rawUrl = `${this.apiURL}api/InterfaceRuleData/getRuleData/${interfacename}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  viewFile(body: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceViewFile/FileData`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  PostFormData(obj: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceForm/InterfaceFormAdd`);
    const transformedBody = this.transformOutboundValueToUTC(obj);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  insertInterfacefromFile(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceForm/InsertInterfacefromFile`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  EntityInsertion(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceForm/Insertentity`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  updateformdata(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceForm/IntFormUpdate`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  createpipeline(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Routes/SavePipeline`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  insertNewPipeline(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InsertPipeline/InsertNewPipeline`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getformdata(value: any) {
    const rawUrl = `${this.apiURL}api/InterfaceForm/InterfaceFormView?userinput=${value}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  finalizeformdata(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceForm/InterfaceFormSubmit`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getproccessorapidata(value: any) {
    const rawUrl = `${this.apiURL}api/Agents/GetByDisplayName?name=${value}&agentid=0&type=Processor&filterflag=true`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getagents(body) {

    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Agents/GetSearchDetails`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getproccessordata(obj: any) {
    const rawUrl = `${this.apiURL}api/Interfacesenderandprocessoragent/Processorandsenderagents?contenttype=${obj.contenttype}&msgtype=${obj.msgtype}&direction=${obj.direction}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getEntityfilterdata(userinput: any) {
    const rawUrl = `${this.apiURL}api/SearchAccounts/GetAccountNamesListAsync?lSearch=${userinput}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getMsgtypedata() {
    const rawUrl = `${this.apiURL}api/Lookup/GetMessageType?lookuptype=messagetype`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getrole(roleid: any, rolename: any) {
    if (roleid == null && rolename == null) {
      const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/UserRoleConfig/GetRoles`);
      return this.httpService.get<any>(transformedUrl, this.header)
        .pipe(
          map(data => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return convertedData;
          })
        );
    }
    // return this.httpService.get<any>(`${this.apiURL}api/RoleMenu/GetRoles?RoleId=0`, this.header);
  }
  getRoleandMenu(rid: number) {
    const rawUrl = `${this.apiURL}api/RoleMenu/GetRoleMenus?RoleId=${rid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  postRoleMenu(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RoleMenu/SaveRoleMenu`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getMenus(rid: number) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RoleMenu/GetMenus`);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  GetActionbyId(mid: number) {
    const rawUrl = `${this.apiURL}api/RoleMenu/GetMenuActionsbyId?MenuId=${mid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  ManageActions(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RoleMenu/SaveAction`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  AddRoles(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RoleMenu/SaveRole`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  eventReprocesses(body, deployement) {
    const header = {
      'Content-Type': 'application/json charset = utf-8',
      'deploymentkey': deployement
    };
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/updateEventstatus`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, { headers: header, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getMirthFilters(column: any, userinput: any) {
    const rawUrl = `${this.apiURL}api/GetMirthLog/GetMirthFilters?column=${column}&userinput=${userinput}&ConnNew=THX`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getEventsList(body, deployement) {
    const header = {
      'Content-Type': 'application/json charset = utf-8',
      'deploymentkey': deployement
    };

    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/searcheventdata`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, { headers: header, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getEventType() {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=Eventtype`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  addIntegrationMapping(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/IntergrationMapping/addIntergration`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  // updateIntegrationMapping(body) {
  //   return this.httpService.post<any>(`${this.apiURL}api/IntergrationMapping/updateIntergration`, body)
  // }
  // hubmessageResolve(id: any, modifiedby: any) {

  //   return this.httpService.put<any>(`${this.apiURL}api/HubMessage/HubMessageStatusUpdate?id=${id}&modifiedby=${modifiedby}&stageid=-1`, '', { withCredentials: true })
  // }
  reprocessapi(body: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceHL7Update/UpdateHL7Integration`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getMirthSearch(body: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/GetMirthLog/GetMirthLog`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  requestUnlock(UniqueID: any, userid: any, isUnlockRequest: any, isApproveUnlock: any, description: any,routeGUID:any,deployement) {
    const header = {
      'Content-Type': 'application/json charset = utf-8',
      'deploymentkey': deployement
    };
    let obj = {
      "routeUniqueID": UniqueID,
      "user": userid,
      "isUnlockRequest": isUnlockRequest,
      "isApproveUnlock": isApproveUnlock,
      "description": description,
      "routeGUID":routeGUID
    }
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Routes/InterfaceLock`);
    const transformedBody = this.transformOutboundValueToUTC(obj);
    return this.httpService.post<any>(transformedUrl, transformedBody, { headers: header, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getContactNames(column: any, userinput: any) {
    const rawUrl = `${this.apiURL}api/ContactModule/GetContactNames?column=${column}&userinput=${userinput}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getContacts(userinput) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/ContactModule/GetContacts`);
    const transformedBody = this.transformOutboundValueToUTC(userinput);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  updateContactModule(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/ContactModule/UpdateContact`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  addNewContact(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/ContactModule/AddContact`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  createContact(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceVendor/VendorContacts?userinput=create`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  updateContact(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceVendor/VendorContacts?userinput=update`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  viewContact(item: any) {
    const rawUrl = `${this.apiURL}api/InterfaceVendor/VendorContactsView?Vendorid=${item}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  contactStatusUpdate() {
    const rawUrl = `${this.apiURL}api/InterfaceVendor/VendorContactsstatusupdate?Contactid=1&Status=0`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  Deletecontact(userinput: any) {
    const rawUrl = `${this.apiURL}api/ContactModule/DeleteContact?userinput=${userinput}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.delete<any>(transformedUrl)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  hl7logsreprocess(body, deployement) {
    // var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    const header = {
      'Content-Type': 'application/json charset = utf-8',
      'deploymentkey': deployement
    };
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXApi/UpdateIntegrationLogdata`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, { headers: header, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  logreprocessStatus() {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=Hl7reprocesslogstatus`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getHl7LogsList(body, deployment) {
    var sessionObject = JSON.parse(sessionStorage.getItem('sessionObjectlogin'));
    const header = {
      'Content-Type': 'application/json charset = utf-8',
      'deploymentkey': deployment
    };
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXApi/GetHl7IntegrationLogdata`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, { headers: header, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  searchlogstatus() {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=Hl7logstatus`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  searchEventStatus() {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=Eventstatus`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getEventList(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/GetCaseData `);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  async searchduplgettapi(urlterm) {
    const headers = {
      'Content-Type': 'application/json charset = utf-8'
    };


    const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
    return await this.httpService.get<any>(transformedUrl, { headers, withCredentials: true })
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      ).toPromise()
      .then(result => result)
      .catch(err => err);

  }



  // this.vbjobapiURL
  getPatienthistory(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PatientHistoryImport/CheckFTPGetFiles`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  submitPatienthistory(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PatientHistoryImport/SaveProjectInfo`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  submitImportPatient(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PatientHistoryImport/SaveHeaderTemplateInfo`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  Patienthistorysummary(user: string) {
    const rawUrl = `${this.apiURL}api/PatientHistoryImport/GetProjectInfo?user=${user}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  previewfile(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PatientHistoryImport/GetFilePreview`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  case360(searchText) {
    const rawUrl = `${this.apiURL}api/Case360/GetEventLogDetails?lSearch=${searchText}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }


  CaseEventAndLogReprocess(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/ReprocessEventsorhl7logs`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  viewFileCase360(logid, routeguid) {
    const rawUrl = `${this.apiURL}api/Case360/GetEventLogFileData?logid=${logid}&routeid=${routeguid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  CaseEventAndLogRegenerate(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/CaseXmlRegeneration`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  exportpatienthistory(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CaseHistoryExport/SaveProjectInfo`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getexportpatienthistory(user: string) {
    const rawUrl = `${this.apiURL}api/CaseHistoryExport/GetProjectInfo?user=${user}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getlookupInfo(param) {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=${param}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getDeployments(param) {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookUpId?lookuptype=${param}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  saveInterfaceForm(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Projects/Save`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  submitInterfaceForm(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Projects/Submit`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  InterfaceFormList(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Projects/GetList`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          // Process serialized JSON string in statusmessage if it exists
          if (typeof convertedData?.statusmessage === 'string') {
            convertedData.statusmessage = this.processSerializedDataWithDateTimeConversion(convertedData.statusmessage);
          }
          return convertedData;
        })
      );
  }

  ProjectFormEdit(projid,projtype){
    const rawUrl = `${this.apiURL}api/Projects/GetProjDetailsById?Projectid=${projid}&type=${projtype}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  getIntContType(looktype) {
    const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=${looktype}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  getInterfaceDetails360(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/case360/GetInterfaceDetailsByCaseId`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getInterfaceDetailsRule(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetRuleAndCaseInfo`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getInterfaceDetailsMessages360(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetHubMessages`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getInterfaceDetailsMessages360Stage(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetHubMessageLogs`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getCaseAuditDetails360(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/case360/GetCaseAuditDetails`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  // getTransactionDetails(body){
  //   return this.httpService.post<any>(`${this.apiURL}api/case360/GetTransactionDetails`,body,this.header)
  // }
  getProjList(projid){
    const rawUrl = `${this.apiURL}api/Projects/GetProjectNames?searchStr=${projid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  pdf64(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Projects/CreatePdf`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getprojects(obj) {
    const rawUrl = `${this.apiURL}api/Projects/GetProjectNames?vendor=${obj.vendorId}&labGuid=${obj.labGuid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  saveprojftpdetails(body)
  {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Pipeline/SavePipelineFtpDetails`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  excel64(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Projects/CreateExcel`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  getcompendium(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Compendium/GetCompendiumResult`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  mailapi(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Projects/sendmail`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  getUpdateFTPInternal() {
    const rawUrl = `${this.apiURL}api/PatientHistoryImport/ReVerifyFTPFiles`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  getProjInterfaces(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Routes/GetSearchDetails`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  refreshpatientImport(PID){
    const rawUrl = `${this.apiURL}api/PatientHistoryImport/GetTransactionBasedDetails?PID=${PID}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  viewFilesCase_hanlder(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/GetStorageFileId`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }


  changeImportProjectStatus(projectid,status){
    let obj={
      PID:projectid.startsWith("0")? projectid.substring(1):projectid,
      Status:status
    }
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PatientHistoryImport/ChangeProjectStatus`);
    const transformedBody = this.transformOutboundValueToUTC(obj);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  viewCases360DXReport(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetFileContent360`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  getDaignostics(routeGuid:string){
    const rawUrl = `${this.apiURL}api/InterfaceStatistics/GetStatistics?RouteGuid=${routeGuid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetPipelineList(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CIISV2/GetPipelineList`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetPipeleDetailsByUniqueID(uniqueID){
    const rawUrl = `${this.apiURL}api/CIISV2/GetPipeleDetailsByUniqueID?uniqueID=${uniqueID}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetDatewiseFailureReasonList(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CIISV2/GetMessageFailureCounts`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  ciisreportexport(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CIISV2/GenerateExcel`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GenerateMappingPDF(input:any){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/MappingPDF/Generate`);
    const transformedBody = this.transformOutboundValueToUTC(input);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  GenerateMappingPDFLive(input:any){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/MappingPDF/GetFileInfo`);
    const transformedBody = this.transformOutboundValueToUTC(input);
    return this.httpService.post<any>(transformedUrl, transformedBody)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetFileContentByFileID(input:any){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/FileServices/GetFileContentByFileID`);
    const transformedBody = this.transformOutboundValueToUTC(input);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  GetStatistics(routeid,sourceagentid){
    const rawUrl = `${this.apiURL}api/InterfaceStatistics/GetStatistics?RouteGuid=${routeid}&agentid=${sourceagentid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  updatessoStatus(update: boolean) {
    this.updatessostatus.next(update)
  }
  createTemplatelhs(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/GetMappings/createTemplate`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  CreateDeviceConnectivity(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VBJobs/GetInstrumentCodes`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetJobSchema(name){
    const rawUrl = `${this.apiURL}api/VBJobs/GetJobSchema?deviceName=${name}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  caseAuditDetails(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetCaseAuditData`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetJobDetails(dname,rid){
    const rawUrl = `${this.apiURL}api/VBJobs/GetJobDetails?agentid=${dname}&routeid=${rid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  //Data Validation API Calls
  sendToTopic(requestBody: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/DataValidation/SendToDataValidationTopic`);
    const transformedBody = this.transformOutboundValueToUTC(requestBody);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  GetInterfaceValidationHistory()
  {
    const rawUrl = `${this.apiURL}api/InterfaceValidation/GetValidationMasterDetails`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  InsertInterfaceValidationHistory(requestBody:any)
  {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceValidation/InsertValidationMaster`);
    const transformedBody = this.transformOutboundValueToUTC(requestBody);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

 GetDatabyMessageIdInfo(piplineguid,fromdate,todate)
  {
    const rawUrl = `${this.apiURL}api/InterfaceValidation/GetValidatedMessagesList?pipelineguid=${piplineguid}&fromdate=${fromdate}&todate=${todate}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  GetMessageDataByMessageId(messageid)
  {
    const rawUrl = `${this.apiURL}api/InterfaceValidation/GetMessageValidationDataByMessageID?messageid=${messageid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  UpdateValidationMaster(requestBody:any)
  {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/InterfaceValidation/UpdateValidationMaster`);
    const transformedBody = this.transformOutboundValueToUTC(requestBody);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  DeleteInterfaceValidatedMessages(PipelineGUID, fromDate, toDate)
  {
    const rawUrl = `${this.apiURL}api/InterfaceValidation/DeleteValidatedMessages?pipelineguid=${PipelineGUID}&fromDate=${fromDate}&toDate=${toDate}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
  GetMessageDetailsByID(messageid){
    const rawUrl = `${this.apiURL}api/DataValidation/GetMessageDetailsByID?messageid=${messageid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  Getvbagentsdetails(acctguid){
    const rawUrl = `${this.apiURL}api/VBJobs/GetVBAgentsDeatilsByAccnGUID?AccountGUID=${acctguid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  getCaseXMLHistory(caseguid){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetCaseXML`);
    const transformedBody = this.transformOutboundValueToUTC(caseguid);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }

  updateCaseXMLToComponent(data:string){
    this.updatCaseXml.next(data)
  }

  SaveRouteNotes(body:any){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Routes/SaveRouteNote`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetInterFaces(vendorid) {
    const rawUrl = `${this.apiURL}api/Vendor/GetInterfaces?vendorid=${vendorid}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  getRegenarateXML(body:any){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/getCaseInfoData`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  SaveRegenarateXML(body:any){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/RegenerateXML`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      )
  }
  GetAccountNamesListAsync(body:any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/SearchAccounts/GetAccountNames`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  getApprovalNotes(projectid:string){
   const rawUrl = `${this.apiURL}api/PatientHistoryImport/GetNoteDeatils?ProjectId=${projectid}`;
   const transformedUrl = this.transformUrlToUTC(rawUrl);
   return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

   SaveApprovalnotes(urlterm, approvalObj) {
         const transformedUrl = this.transformUrlToUTC(this.apiURL + urlterm);
         const transformedBody = this.transformOutboundValueToUTC(approvalObj);
         return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
           .pipe(
             map(data => {
               //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
               const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
               return convertedData;
             })
           );
    }

    reprocessBymsgID(input:any){
      const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/HubMessage/GetMessageDetailById`);
      const transformedBody = this.transformOutboundValueToUTC(input);
      return this.httpService.post<any>(transformedUrl, transformedBody)
        .pipe(
          map(data => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return convertedData;
          })
        );
    }
    getPdf( pdfname:string) {
      const rawUrl = `${this.apiURL}api/PatientHistoryImport/getPDfFile?pdfName=${pdfname}`;
      const transformedUrl = this.transformUrlToUTC(rawUrl);
      return this.httpService.get<any>(transformedUrl, this.header)
        .pipe(
          map(data => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return convertedData;
          })
        );
 }
 GetSuccessMessageList(body){
 const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CIISV2/GetSuccessMessageList`);
 const transformedBody = this.transformOutboundValueToUTC(body);
 return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
  .pipe(
    map(data => {
      //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
      const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
      return convertedData;
    })
  )
}
getvbdiagnostic( value:string){
  const rawUrl = `${this.apiURL}api/VBJobs/getvbdiagnostic?input=${value}`;
  const transformedUrl = this.transformUrlToUTC(rawUrl);
  return this.httpService.get<any>(transformedUrl,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

getErrorFileInfo(body) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PatientHistoryImport/getErrorFiles`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
  // Pin/Unpin Message API methods
  pinMessage(messageId: string, routeGuid: string, pinnedBy: string, reason?: string, pinName?: string) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PinMessage/PinMessage`);
    const requestBody = {
      messageId: messageId,
      routeGuid: routeGuid,
      pinnedBy: pinnedBy,
      reason: reason || '',
      pinName: pinName || ''
    };
    const transformedBody = this.transformOutboundValueToUTC(requestBody);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  unpinMessage(messageId: string, routeGuid: string, pinnedBy: string) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PinMessage/UnPinMessage`);
    let params = new HttpParams();
    params = params.set('routeGuid', routeGuid);
    params = params.set('messageId', messageId);
    params = params.set('pinnedBy', pinnedBy);
    const options = {
      ...this.header,
      params: params
    };
    return this.httpService.post<any>(transformedUrl, {}, options)
      .pipe(
        map(data => {
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }


  getPinnedMessages(routeGuid: string) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/PinMessage/Getpinnedmessages`);
    let params = new HttpParams();
    params = params.set('routeGuid', routeGuid);
    const options = {
      ...this.header,
      params: params
    };
    return this.httpService.get<any>(transformedUrl, options)
      .pipe(
        debounceTime(500),
        map(data => {
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

  getFileContentByMessageid(body) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/FileContectByMessageID/GetFileContectByMessageID`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
getCoreCache(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CoreCache/GetAllCache`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
getClearCache(input:any){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/CoreCache/Deletecorecache`);
  const transformedBody = this.transformOutboundValueToUTC(input);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
getCase360Parameter() {
  const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=Case360Parameter`;
  const transformedUrl = this.transformUrlToUTC(rawUrl);
  return this.httpService.get<any>(transformedUrl, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

Case360search(searchTerm){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetCaseInfoByAccession`);
    const transformedBody = this.transformOutboundValueToUTC(searchTerm);
    return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
}
getvbjobsdetail(body) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VBJobs/GetVbJobDetailsForDiagnostics`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
repopulateCaseId(input:any){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/ReGenerateCaseClaim`);
  const transformedBody = this.transformOutboundValueToUTC(input);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    )
}

updateIntegrationMapping(body) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/UpdateIntegrationmapping`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    )
}

  GetVatraceLogs(body) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VaTraceLogs/GetVatraceLogs`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }

CreateIntegrationmapping(body) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalHubDXAPI/CreateIntegrationmapping`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    )
}

GetVBCheckPortExists(agentId: string,port: number) {
  const rawUrl = `${this.apiURL}api/VBJobs/GetVBCheckPortExists?agentId=${agentId}&port=${port}`;
  const transformedUrl = this.transformUrlToUTC(rawUrl);
  return this.httpService.get<any>(transformedUrl, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

Getcomponentbyname(displayname:string){
  let obj=this.ComponentsList.find(V=>V.DisplayName===displayname.toLowerCase());
  if(obj!=undefined){
    return obj.componentname;
  }else{
    return '';
  }
  
}
GetCaseClaimDetails(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Case360/GetCaseClaimDetails`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
saveVBJob(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VBJobs/SaveVBFileJob`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody,this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
getpatienthistorydetails(id){
  const rawUrl = `${this.apiURL}api/PatientHistoryImport/CheckFTPGetFilesV2?projectid=${id}`;
  const transformedUrl = this.transformUrlToUTC(rawUrl);
  return this.httpService.get<any>(transformedUrl,this.headers)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
getOrderRouteByprojectId(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Routes/GetOrderRouteByProjectId`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
UpdateValidateField(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Routes/UpdateFieldValidate`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
  }

GetAgentEndpoint(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/AgentEndPoint/GetAgentEndpoint`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
}
SaveAgentEndPoint(body){
      const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/AgentEndPoint/SaveAgentEndPoint`);
      const transformedBody = this.transformOutboundValueToUTC(body);
      return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
        .pipe(
          map(data => {
            //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
            const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
            return convertedData;
          })
        );
}
DeleteAgentEndpoint(body){
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/AgentEndPoint/DeleteAgentEndpoint`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
}


GetUpdateVBJobPayload(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/Pipeline/GetUpdateVBJobPayload`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

validateRule(payload: { xml: string, routeid: string }) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RuleEngineReports/ValidateRule`);
  const transformedBody = this.transformOutboundValueToUTC(payload);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

GetQualifiedRoutesForXML(payload: { xml: string, sourceagent: string ,messagetype: string}) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RuleEngineReports/GetQualifiedRoutesForXML`);
  const transformedBody = this.transformOutboundValueToUTC(payload);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    )
}


GetAgentByDirectionAndDeployment(direction,deployment){ 
  const rawUrl = `${this.apiURL}api/Agents/GetAgentByDirectionAndDeployment?direction=${direction}&deployment=${deployment}`;
  const transformedUrl = this.transformUrlToUTC(rawUrl);
  return this.httpService.get<any>(transformedUrl, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

GetVAEventInfo(body: any) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RuleEngineReports/GetVAEventInfo`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

DeleteVAEventInfo(body: any) {
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RuleEngineReports/DeleteVAEventInfo`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}

  UpdateInsertVAEventInfo(body: any) {
    const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/RuleEngineReports/InsertOrUpdateEventInfo`);
    const transformedBody = this.transformOutboundValueToUTC(body);
    return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
  }
GetSSOLoginData(encryptedVal: string) {
    const rawUrl = `${this.apiURL}SSOLaunch?Input=${encryptedVal}`;
    const transformedUrl = this.transformUrlToUTC(rawUrl);
    return this.httpService.get<any>(transformedUrl, this.header)
      .pipe(
        map(data => {
          //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
          const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
          return convertedData;
        })
      );
}
getVitalReportUrl(body){
  const transformedUrl = this.transformUrlToUTC(`${this.apiURL}api/VitalStats/GetVitalStatsURL`);
  const transformedBody = this.transformOutboundValueToUTC(body);
  return this.httpService.post<any>(transformedUrl, transformedBody, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
getAllowedInterfaceAndMessageTypes() : Observable<LookUp[]>{
  const rawUrl = `${this.apiURL}api/Lookup/GetLookupTypelist?lookuptype=RuleEngineEnableFor`;
  const transformedUrl = this.transformUrlToUTC(rawUrl);
  return this.httpService.get<any>(transformedUrl, this.header)
    .pipe(
      map(data => {
        //Here check each of the properties of the response and then convert the datetime datatypes to the user selected timezone.
        const convertedData = this.transformDatesDeep(data, { dateStyle: 'medium', timeStyle: 'short' });
        return convertedData;
      })
    );
}
 hl7VASpec = {
  "MSH": [
    {
      "segindex": 1,
      "segfield": "Field Separator",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Encoding Characters",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Sending Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Sending Facility",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Receiving Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Receiving Facility",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Message",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Message Type",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Message Control ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Processing ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Version ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Accept Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Application Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Country Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PID": [
    {
      "segindex": 1,
      "segfield": "Set ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Patient ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Patient Identifier List",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Alternate Patient ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Patient Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Birth",
      "segtype": "DOB",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Patient Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 13,
      "segfield": "Phone Number-Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Phone Number-Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "SSN Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ethnicity",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],

  "EVN":[
    {
      "segindex": 1,
      "segfield": "Event Type Code [ID]*",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
    "segindex": 2,
    "segfield": "Recorded Date/Time [TS]",
    "segtype": "",
    "segvalue": "",
    "segcomponent": []
    }
  ],
  "ZEF":[
    {
      "segindex": 1,
      "segfield": "Set ID - ZEF",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Embedded Content",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Sending Application",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Document Type",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": " Encoding Technology ",

          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Embedded Content",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
    ]
    },

  ],
  "PV1": [
    {
      "segindex": 1,
      "segfield": "Set ID-PV1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
      ]
    },
    {
      "segindex": 7,
      "segfield": "Attending Doctor",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Ordering Physician NPI",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Ordering Physician Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Ordering Physician First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 6,
          "segfield": "Prefix",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 7,
          "segfield": "Degree",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Referring Doctor",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Visit Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN1": [
    {
      "segindex": 1,
      "segfield": "Set ID-IN1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insurance Plan ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Insurance Company ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Insurance Company Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Insurance Company Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Group Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Group Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Plan Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Name of Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 17,
      "segfield": "Insured's Relationship to Patient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Insured's Date of Birth",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "Policy Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "Insured's Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "GT1": [
    {
      "segindex": 1,
      "segfield": "Set ID-GT1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Guarantor Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 5,
      "segfield": "Guarantor Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 6,
      "segfield": "Guarantor Ph Num –Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Guarantor Ph Num Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Guarantor Relationship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ORC": [
    {
      "segindex": 1,
      "segfield": "Order Control",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Placer Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Filler Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Placer Group Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Parent Order",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Date/Time of Transaction",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Ordering Provider",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "NPI",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 21,
      "segfield": "Ordering Facility Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ordering Facility Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Ordering Facility Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Ordering Provider Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "OBR": [
    {
      "segindex": 1,
      "segfield": "Set ID - OBR",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Placer Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Filler Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Universal Service Identifier",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Order Code",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Case Type Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "Alternate Identifier",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Alternate Text",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 6,
          "segfield": "Name of Alternate Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 7,
      "segfield": "Observation Date/Time",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Collection Volume",
      "segtype": "CollectionDate",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Collector Identifier",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 13,
      "segfield": "Relevant Clinical Information",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Specimen Received Date/Time",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Specimen Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Ordering Provider",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "NPI",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 18,
      "segfield": "Placer Field 1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Placer Field 2",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 20,
      "segfield": "Filler Field 1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 21,
      "segfield": "Filler Field 2",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Results Rpt/Status Chng - Date/Time",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Diagnostic Serv Sect ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Result Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 28,
      "segfield": "Result Copies To",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 29,
      "segfield": "Parent Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 34,
      "segfield": "Technician",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 35,
      "segfield": "Transcriptionist",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 37,
      "segfield": "Number of Sample Containers *",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 38,
      "segfield": "Transport Logistics of Collected Sample",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 39,
      "segfield": "Collector's Comment *",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 44,
      "segfield": "Procedure Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 45,
      "segfield": "Procedure Code Modifier",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 46,
      "segfield": "Placer Supplemental Service Information",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 47,
      "segfield": "Filler Supplemental Service Information",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 37,
      "segfield": "Number of Sample Containers *",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "DG1": [
    {
      "segindex": 1,
      "segfield": "Set ID-DG1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Diagnosis Coding Method",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Diagnosis Code - DG1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "ICD Code",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Description",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    }
  ],
  "OBX": [
    {
      "segindex": 1,
      "segfield": "Set ID - OBX",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Value Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 3,
      "segfield": "Observation Identifier",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Identifier",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Text",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": " Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }

      ]
  },
   {
      "segindex": 4,
      "segfield": "Observation Sub-ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },




    {
      "segindex": 5,
      "segfield": "Observation Value",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": " Sending Application",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": " Document Type",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": " - Encoding Technology",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
		 {
          "segindex": 5,
          "segfield": " - Embedded Content",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },

      ]
    },
	{
      "segindex": 6,
      "segfield": "Units",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "References Range",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Abnormal Flags",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Observation Result status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Date/Time of the Observation",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Responsible Observer",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Equipment Instance Identifier",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Date/Time of the  Analysis",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Performing Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Performing Organization Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Performing Organization Medical Director ",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],

  "NTE": [
    {
      "segindex": 1,
      "segfield": "Set ID-NTE",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Source of Comment",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Comment",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Comment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Observation Value",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ZPS": [
    {
      "segindex": 1,
      "segfield": "Set ID-ZPS",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Physician Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN2": [
    {
      "segindex": 1,
      "segfield": "Insured's Employee ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insured's Social Security Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "	Insured's Employer's Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Employer Information Data",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Mail Claim Party",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Medicare Health Ins Card Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Medicaid Case Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "	Medicaid Case Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Military Sponsor Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Military ID Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "	Dependent Of Military Recipient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "	Military Organization",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 13,
      "segfield": "	Military Station",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Military Service",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Military Rank/Grade",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Military Retire Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Baby Coverage",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 20,
      "segfield": "Combine Baby Bill",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 21,
      "segfield": "Blood Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Special Coverage Approval Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Special Coverage Approval Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex":24,
      "segfield": "Non-Covered Insurance Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Payor ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 26,
      "segfield": "	Payor Subscriber ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 27,
      "segfield": "Eligibility Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 28,
      "segfield": "Room Coverage Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 29,
      "segfield": "Policy Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 30,
      "segfield": "Daily Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 31,
      "segfield": "Living Dependency",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 32,
      "segfield": "Ambulatory Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 33,
      "segfield": "Citizenship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 34,
      "segfield": "Primary Language",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 35,
      "segfield": "Living Arrangement",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "	Publicity Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 37,
      "segfield": "	Protection Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 38,
      "segfield": "Student Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 39,
      "segfield": "	Religion",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 40,
      "segfield": "Mother's Maiden Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 41,
      "segfield": "Sequence Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 42,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 44,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 45,
      "segfield": "Employment Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 46,
      "segfield": "Job Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 47,
      "segfield": "Job Code/Class",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 48,
      "segfield": "Job Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 49,
      "segfield": "Employer Contact Person Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 50,
      "segfield": "Employer Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 51,
      "segfield": "Employer Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 52,
      "segfield": "Insured's Contact Person's Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 53,
      "segfield": "Insured's Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 54,
      "segfield": "Insured's Contact Person Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 55,
      "segfield": "Relationship to the Patient Start Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 56,
      "segfield": "Relationship to the Patient Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 57,
      "segfield": "Insurance Co Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 58,
      "segfield": "Insurance Co Contact Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 59,
      "segfield": "Policy Scope",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 60,
      "segfield": "Policy Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 61,
      "segfield": "Patient Member Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 62,
      "segfield": "Guarantor's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 63,
      "segfield": "Insured's Phone Number - Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 64,
      "segfield": "Insured's Employer Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 65,
      "segfield": "Military Handicapped Program",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 66,
      "segfield": "Suspend Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 67,
      "segfield": "Copay Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 68,
      "segfield": "Stoploss Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 69,
      "segfield": "	Insured Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 70,
      "segfield": "Insured Employer Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 71,
      "segfield": "	Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 72,
      "segfield": "Patient's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 73,
      "segfield": "Co-Pay Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

  ]
};
 ORU={
  "MSH": [
    {
      "segindex": 1,
      "segfield": "Field Separator",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Encoding Characters",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Sending Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Sending Facility",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Receiving Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Receiving Facility",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Message",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Message Type",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Message Control ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Processing ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Version ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Accept Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Application Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Country Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PID": [
    {
      "segindex": 1,
      "segfield": "Set ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Patient ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Patient Identifier List",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Alternate Patient ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Patient Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Birth",
      "segtype": "DOB",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Patient Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 13,
      "segfield": "Phone Number-Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Phone Number-Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "SSN Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ethnicity",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PV1": [
    {
      "segindex": 1,
      "segfield": "Set ID-PV1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
      ]
    },
    {
      "segindex": 7,
      "segfield": "Attending Doctor",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Ordering Physician NPI",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Ordering Physician Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Ordering Physician First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 6,
          "segfield": "Prefix",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 7,
          "segfield": "Degree",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Referring Doctor",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Visit Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "DG1": [
    {
      "segindex": 1,
      "segfield": "Set ID-DG1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Diagnosis Coding Method",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Diagnosis Code - DG1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "ICD Code",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Description",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    }
  ],
  "NTE": [
    {
      "segindex": 1,
      "segfield": "Set ID-NTE",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Source of Comment",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Comment",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Comment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Observation Value",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ZEF":[
    {
      "segindex": 1,
      "segfield": "Set ID - ZEF",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Embedded Content",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Sending Application",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Document Type",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": " Encoding Technology ",

          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Embedded Content",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
    ]
    },

  ],
  "OBR": [
    {
      "segindex": 1,
      "segfield": "Set ID - OBR",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Placer Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Filler Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Universal Service Identifier",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Order Code",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Case Type Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }

      ]
    },
    {
      "segindex": 7,
      "segfield": "Observation Date/Time",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

    {
      "segindex": 13,
      "segfield": "Relevant Clinical Information",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Specimen Received Date/Time",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Specimen Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Ordering Provider",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "NPI",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },

    {
      "segindex": 22,
      "segfield": "Results Rpt/Status Chng - Date/Time",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

    {
      "segindex": 25,
      "segfield": "Result Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

    {
      "segindex": 37,
      "segfield": "Number of Sample Containers *",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

    {
      "segindex": 46,
      "segfield": "Placer Supplemental Service Information",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 47,
      "segfield": "Filler Supplemental Service Information",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

  ],
  "OBX": [
    {
      "segindex": 1,
      "segfield": "Set ID - OBX",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Value Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 3,
      "segfield": "Observation Identifier",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Identifier",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Text",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": " Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }

      ]
  },
   {
      "segindex": 4,
      "segfield": "Observation Sub-ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },




    {
      "segindex": 5,
      "segfield": "Observation Value",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": " Sending Application",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": " Document Type",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": " - Encoding Technology",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
		 {
          "segindex": 5,
          "segfield": " - Embedded Content",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },

      ]
    },
	{
      "segindex": 6,
      "segfield": "Units",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "References Range",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Abnormal Flags",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Observation Result status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Date/Time of the Observation",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Responsible Observer",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Equipment Instance Identifier",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Date/Time of the  Analysis",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Performing Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Performing Organization Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Performing Organization Medical Director ",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ORC": [
    {
      "segindex": 1,
      "segfield": "Order Control",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Placer Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Filler Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Placer Group Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Parent Order",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Date/Time of Transaction",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Ordering Provider",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "NPI",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 21,
      "segfield": "Ordering Facility Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ordering Facility Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Ordering Facility Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Ordering Provider Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ZPS": [
    {
      "segindex": 1,
      "segfield": "Set ID-ZPS",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Physician Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN2": [
    {
      "segindex": 1,
      "segfield": "Insured's Employee ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insured's Social Security Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "	Insured's Employer's Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Employer Information Data",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Mail Claim Party",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Medicare Health Ins Card Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Medicaid Case Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "	Medicaid Case Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Military Sponsor Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Military ID Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "	Dependent Of Military Recipient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "	Military Organization",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 13,
      "segfield": "	Military Station",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Military Service",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Military Rank/Grade",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Military Retire Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Baby Coverage",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 20,
      "segfield": "Combine Baby Bill",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 21,
      "segfield": "Blood Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Special Coverage Approval Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Special Coverage Approval Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex":24,
      "segfield": "Non-Covered Insurance Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Payor ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 26,
      "segfield": "	Payor Subscriber ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 27,
      "segfield": "Eligibility Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 28,
      "segfield": "Room Coverage Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 29,
      "segfield": "Policy Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 30,
      "segfield": "Daily Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 31,
      "segfield": "Living Dependency",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 32,
      "segfield": "Ambulatory Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 33,
      "segfield": "Citizenship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 34,
      "segfield": "Primary Language",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 35,
      "segfield": "Living Arrangement",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "	Publicity Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 37,
      "segfield": "	Protection Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 38,
      "segfield": "Student Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 39,
      "segfield": "	Religion",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 40,
      "segfield": "Mother's Maiden Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 41,
      "segfield": "Sequence Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 42,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 44,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 45,
      "segfield": "Employment Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 46,
      "segfield": "Job Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 47,
      "segfield": "Job Code/Class",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 48,
      "segfield": "Job Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 49,
      "segfield": "Employer Contact Person Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 50,
      "segfield": "Employer Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 51,
      "segfield": "Employer Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 52,
      "segfield": "Insured's Contact Person's Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 53,
      "segfield": "Insured's Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 54,
      "segfield": "Insured's Contact Person Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 55,
      "segfield": "Relationship to the Patient Start Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 56,
      "segfield": "Relationship to the Patient Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 57,
      "segfield": "Insurance Co Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 58,
      "segfield": "Insurance Co Contact Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 59,
      "segfield": "Policy Scope",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 60,
      "segfield": "Policy Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 61,
      "segfield": "Patient Member Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 62,
      "segfield": "Guarantor's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 63,
      "segfield": "Insured's Phone Number - Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 64,
      "segfield": "Insured's Employer Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 65,
      "segfield": "Military Handicapped Program",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 66,
      "segfield": "Suspend Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 67,
      "segfield": "Copay Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 68,
      "segfield": "Stoploss Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 69,
      "segfield": "	Insured Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 70,
      "segfield": "Insured Employer Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 71,
      "segfield": "	Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 72,
      "segfield": "Patient's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 73,
      "segfield": "Co-Pay Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

  ]
}
 DFT={
  "MSH": [
    {
      "segindex": 1,
      "segfield": "Field Separator",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Encoding Characters",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Sending Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Sending Facility",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Receiving Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Receiving Facility",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Message",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Message Type",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Message Control ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Processing ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Version ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Accept Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Application Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Country Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PID": [
    {
      "segindex": 1,
      "segfield": "Set ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Patient ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Patient Identifier List",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Alternate Patient ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Patient Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Birth",
      "segtype": "DOB",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Patient Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 13,
      "segfield": "Phone Number-Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Phone Number-Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "SSN Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ethnicity",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PV1": [
    {
      "segindex": 1,
      "segfield": "Set ID-PV1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
      ]
    },
    {
      "segindex": 7,
      "segfield": "Attending Doctor",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Ordering Physician NPI",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Ordering Physician Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Ordering Physician First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 6,
          "segfield": "Prefix",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 7,
          "segfield": "Degree",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Referring Doctor",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Visit Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "DG1": [
    {
      "segindex": 1,
      "segfield": "Set ID-DG1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Diagnosis Coding Method",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Diagnosis Code - DG1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "ICD Code",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Description",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    }
  ],
  "GT1": [
    {
      "segindex": 1,
      "segfield": "Set ID-GT1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Guarantor Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 5,
      "segfield": "Guarantor Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 6,
      "segfield": "Guarantor Ph Num –Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Guarantor Ph Num Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Guarantor Relationship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN1": [
    {
      "segindex": 1,
      "segfield": "Set ID-IN1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insurance Plan ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Insurance Company ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Insurance Company Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Insurance Company Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Group Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Group Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Plan Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Name of Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 17,
      "segfield": "Insured's Relationship to Patient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Insured's Date of Birth",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "Policy Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "Insured's Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
	{
      "segindex": 47,
      "segfield": "Coverage Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],

  "FT1": [
    {
      "segindex": 1,
      "segfield": "Set ID – FT1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Transaction ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Transaction Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Transaction Posting Date",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 6,
      "segfield": "Transaction Type",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 10,
      "segfield": "Transaction Quantity",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 13,
      "segfield": "Department Code",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 16,
      "segfield": "Patient Location",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
	{
      "segindex": 19,
      "segfield": "Diagnosis ICD Code",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 20,
      "segfield": "Performed By",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "ID number",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Suffix",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
     {
      "segindex": 21,
      "segfield": "Ordered By",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "ID number",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Suffix",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 23,
      "segfield": "Filler Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Procedure Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 26,
      "segfield": "Procedure Code Modifier",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
       }
  ],
  "NTE": [
    {
      "segindex": 1,
      "segfield": "Set ID-NTE",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Source of Comment",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Comment",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Comment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Observation Value",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ZEF":[
    {
      "segindex": 1,
      "segfield": "Set ID - ZEF",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Embedded Content",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Sending Application",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Document Type",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": " Encoding Technology ",

          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Embedded Content",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
    ]
    },

  ],
  "OBX": [
    {
      "segindex": 1,
      "segfield": "Set ID - OBX",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Value Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
	 {
      "segindex": 3,
      "segfield": "Observation Identifier",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Identifier",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Text",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": " Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }

      ]
  },
   {
      "segindex": 4,
      "segfield": "Observation Sub-ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },




    {
      "segindex": 5,
      "segfield": "Observation Value",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": " Sending Application",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": " Document Type",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": " - Encoding Technology",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
		 {
          "segindex": 5,
          "segfield": " - Embedded Content",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },

      ]
    },
	{
      "segindex": 6,
      "segfield": "Units",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "References Range",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Abnormal Flags",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Observation Result status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Date/Time of the Observation",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Responsible Observer",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Equipment Instance Identifier",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Date/Time of the  Analysis",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Performing Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Performing Organization Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Performing Organization Medical Director ",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ZPS": [
    {
      "segindex": 1,
      "segfield": "Set ID-ZPS",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Physician Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN2": [
    {
      "segindex": 1,
      "segfield": "Insured's Employee ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insured's Social Security Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "	Insured's Employer's Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Employer Information Data",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Mail Claim Party",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Medicare Health Ins Card Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Medicaid Case Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "	Medicaid Case Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Military Sponsor Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Military ID Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "	Dependent Of Military Recipient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "	Military Organization",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 13,
      "segfield": "	Military Station",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Military Service",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Military Rank/Grade",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Military Retire Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Baby Coverage",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 20,
      "segfield": "Combine Baby Bill",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 21,
      "segfield": "Blood Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Special Coverage Approval Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Special Coverage Approval Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex":24,
      "segfield": "Non-Covered Insurance Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Payor ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 26,
      "segfield": "	Payor Subscriber ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 27,
      "segfield": "Eligibility Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 28,
      "segfield": "Room Coverage Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 29,
      "segfield": "Policy Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 30,
      "segfield": "Daily Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 31,
      "segfield": "Living Dependency",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 32,
      "segfield": "Ambulatory Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 33,
      "segfield": "Citizenship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 34,
      "segfield": "Primary Language",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 35,
      "segfield": "Living Arrangement",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "	Publicity Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 37,
      "segfield": "	Protection Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 38,
      "segfield": "Student Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 39,
      "segfield": "	Religion",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 40,
      "segfield": "Mother's Maiden Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 41,
      "segfield": "Sequence Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 42,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 44,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 45,
      "segfield": "Employment Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 46,
      "segfield": "Job Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 47,
      "segfield": "Job Code/Class",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 48,
      "segfield": "Job Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 49,
      "segfield": "Employer Contact Person Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 50,
      "segfield": "Employer Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 51,
      "segfield": "Employer Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 52,
      "segfield": "Insured's Contact Person's Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 53,
      "segfield": "Insured's Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 54,
      "segfield": "Insured's Contact Person Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 55,
      "segfield": "Relationship to the Patient Start Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 56,
      "segfield": "Relationship to the Patient Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 57,
      "segfield": "Insurance Co Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 58,
      "segfield": "Insurance Co Contact Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 59,
      "segfield": "Policy Scope",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 60,
      "segfield": "Policy Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 61,
      "segfield": "Patient Member Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 62,
      "segfield": "Guarantor's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 63,
      "segfield": "Insured's Phone Number - Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 64,
      "segfield": "Insured's Employer Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 65,
      "segfield": "Military Handicapped Program",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 66,
      "segfield": "Suspend Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 67,
      "segfield": "Copay Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 68,
      "segfield": "Stoploss Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 69,
      "segfield": "	Insured Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 70,
      "segfield": "Insured Employer Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 71,
      "segfield": "	Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 72,
      "segfield": "Patient's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 73,
      "segfield": "Co-Pay Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

  ]
}
  BAR={
  "MSH": [
    {
      "segindex": 1,
      "segfield": "Field Separator",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Encoding Characters",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Sending Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Sending Facility",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Receiving Application",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Receiving Facility",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Message",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Message Type",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Message Control ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Processing ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Version ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Accept Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Application Acknowledgment Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Country Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PID": [
    {
      "segindex": 1,
      "segfield": "Set ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Patient ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Patient Identifier List",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Alternate Patient ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Patient Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 7,
      "segfield": "Date/Time of Birth",
      "segtype": "DOB",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Patient Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 13,
      "segfield": "Phone Number-Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Phone Number-Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "SSN Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ethnicity",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "PV1": [
    {
      "segindex": 1,
      "segfield": "Set ID-PV1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
      ]
    },
    {
      "segindex": 7,
      "segfield": "Attending Doctor",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Ordering Physician NPI",
          "segtype": "NOTEMPTY",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Ordering Physician Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Ordering Physician First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 6,
          "segfield": "Prefix",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 7,
          "segfield": "Degree",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Referring Doctor",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Visit Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "DG1": [
    {
      "segindex": 1,
      "segfield": "Set ID-DG1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Diagnosis Coding Method",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Diagnosis Code - DG1",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "ICD Code",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Description",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Name of Coding System",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    }
  ],
  "GT1": [
    {
      "segindex": 1,
      "segfield": "Set ID-GT1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Guarantor Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 5,
      "segfield": "Guarantor Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 6,
      "segfield": "Guarantor Ph Num –Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Guarantor Ph Num Business",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "Guarantor Relationship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN1": [
    {
      "segindex": 1,
      "segfield": "Set ID-IN1",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insurance Plan ID",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Insurance Company ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Insurance Company Name",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Insurance Company Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Street Address",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Other Designation",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "City",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 4,
          "segfield": "State",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 5,
          "segfield": "Zip",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 8,
      "segfield": "Group Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Group Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Plan Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Name of Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "Middle Initial",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 17,
      "segfield": "Insured's Relationship to Patient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Insured's Date of Birth",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "Policy Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "Insured's Administrative Sex",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
	{
      "segindex": 47,
      "segfield": "Coverage Type",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "ZPS": [
    {
      "segindex": 1,
      "segfield": "Set ID-ZPS",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Organization Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Physician Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
  "IN2": [
    {
      "segindex": 1,
      "segfield": "Insured's Employee ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Insured's Social Security Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "	Insured's Employer's Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Employer Information Data",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 5,
      "segfield": "Mail Claim Party",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 6,
      "segfield": "Medicare Health Ins Card Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 7,
      "segfield": "Medicaid Case Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "	Medicaid Case Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Military Sponsor Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 10,
      "segfield": "Military ID Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 11,
      "segfield": "	Dependent Of Military Recipient",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "	Military Organization",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 13,
      "segfield": "	Military Station",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 14,
      "segfield": "Military Service",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 15,
      "segfield": "Military Rank/Grade",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 16,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 17,
      "segfield": "Military Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 18,
      "segfield": "Military Retire Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 19,
      "segfield": "Baby Coverage",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 20,
      "segfield": "Combine Baby Bill",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 21,
      "segfield": "Blood Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Special Coverage Approval Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Special Coverage Approval Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex":24,
      "segfield": "Non-Covered Insurance Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 25,
      "segfield": "Payor ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 26,
      "segfield": "	Payor Subscriber ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 27,
      "segfield": "Eligibility Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 28,
      "segfield": "Room Coverage Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 29,
      "segfield": "Policy Type/Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 30,
      "segfield": "Daily Deductible",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 31,
      "segfield": "Living Dependency",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 32,
      "segfield": "Ambulatory Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 33,
      "segfield": "Citizenship",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 34,
      "segfield": "Primary Language",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 35,
      "segfield": "Living Arrangement",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 36,
      "segfield": "	Publicity Code",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 37,
      "segfield": "	Protection Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 38,
      "segfield": "Student Indicator",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 39,
      "segfield": "	Religion",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 40,
      "segfield": "Mother's Maiden Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 41,
      "segfield": "Sequence Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 42,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 43,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 44,
      "segfield": "undefined",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 45,
      "segfield": "Employment Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 46,
      "segfield": "Job Title",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 47,
      "segfield": "Job Code/Class",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 48,
      "segfield": "Job Status",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 49,
      "segfield": "Employer Contact Person Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 50,
      "segfield": "Employer Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 51,
      "segfield": "Employer Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 52,
      "segfield": "Insured's Contact Person's Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 53,
      "segfield": "Insured's Contact Person Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 54,
      "segfield": "Insured's Contact Person Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 55,
      "segfield": "Relationship to the Patient Start Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 56,
      "segfield": "Relationship to the Patient Stop Date",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 57,
      "segfield": "Insurance Co Contact Reason",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 58,
      "segfield": "Insurance Co Contact Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 59,
      "segfield": "Policy Scope",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 60,
      "segfield": "Policy Source",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 61,
      "segfield": "Patient Member Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 62,
      "segfield": "Guarantor's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 63,
      "segfield": "Insured's Phone Number - Home",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 64,
      "segfield": "Insured's Employer Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 65,
      "segfield": "Military Handicapped Program",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 66,
      "segfield": "Suspend Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 67,
      "segfield": "Copay Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 68,
      "segfield": "Stoploss Limit Flag",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 69,
      "segfield": "	Insured Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 70,
      "segfield": "Insured Employer Organization Name and ID",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 71,
      "segfield": "	Race",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 72,
      "segfield": "Patient's Relationship to Insured",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 73,
      "segfield": "Co-Pay Amount",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },

  ],
  "ORC": [
    {
      "segindex": 1,
      "segfield": "Order Control",
      "segtype": "NOTEMPTY",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 2,
      "segfield": "Placer Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 3,
      "segfield": "Filler Order Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 4,
      "segfield": "Placer Group Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 8,
      "segfield": "Parent Order",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 9,
      "segfield": "Date/Time of Transaction",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 12,
      "segfield": "Ordering Provider",
      "segtype": "",
      "segvalue": "",
      "segcomponent": [
        {
          "segindex": 1,
          "segfield": "NPI",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 2,
          "segfield": "Last Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        },
        {
          "segindex": 3,
          "segfield": "First Name",
          "segtype": "",
          "segvalue": "",
          "segcomponent": []
        }
      ]
    },
    {
      "segindex": 21,
      "segfield": "Ordering Facility Name",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 22,
      "segfield": "Ordering Facility Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 23,
      "segfield": "Ordering Facility Phone Number",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    },
    {
      "segindex": 24,
      "segfield": "Ordering Provider Address",
      "segtype": "",
      "segvalue": "",
      "segcomponent": []
    }
  ],
}
}